export const SOFT_DELETE_MODULE_OPTIONS = Symbol('SOFT_DELETE_MODULE_OPTIONS');
export const SOFT_DELETE_PRISMA_SERVICE = Symbol('SOFT_DELETE_PRISMA_SERVICE');
export const WITH_DELETED_KEY = 'SOFT_DELETE_WITH_DELETED';
export const ONLY_DELETED_KEY = 'SOFT_DELETE_ONLY_DELETED';
export const SKIP_SOFT_DELETE_KEY = 'SOFT_DELETE_SKIP';
export const WITH_DELETED_RELATIONS_KEY = 'SOFT_DELETE_WITH_DELETED_RELATIONS';
export const DEFAULT_DELETED_AT_FIELD = 'deletedAt';
export const DEFAULT_MAX_CASCADE_DEPTH = 3;
export const SOFT_DELETE_EVENT_EMITTER = Symbol('SOFT_DELETE_EVENT_EMITTER');
